import React, {useState} from 'react'
import {useSolv} from "./components/SolvProvider";
import {useIntlEx} from "./components/IntlUtils.js"
import {clearAllErrors, showError, validateField} from './components/ValidationUtils.js';
import {closeDialog, ModalDialog} from "./components/DialogUtils.js"
import getLogger from "./components/Logging.js"
import './App.css'
import {ActionButton, Alert, FormGroup} from "./components/FormComps";
import {AsyncPaginate} from "react-select-async-paginate";
import {mkExtraParams} from "./components/TableComps";
import {TagBox, TagLabel} from "./components/TagBox";
import {shortIdEqual} from "./components/StringUtils";

const log = getLogger("MemberMoveDialog")

export default function MemberMoveDialog(props) {

  const {api, session, setBusy} = useSolv()
  const {intl} = useIntlEx()

  const [touched, setTouched] = useState(null)
  const [alert, setAlert] = useState(null)

  const [targetTenant, setTargetTenant] = useState(null)

  function isInvitation() {
    return (props.row?.status === "INVITING")
  }

  function isMe() {
    return session?.user?.userId.replace(/\-/g, "") === props.row?.userId?.replace(/\-/g, "")
  }

  function isOwner() {
    return (props.row?.userLevel === 100)
  }

  function validate() {

    let opt = {focusEl: null, valid: true}

    clearAllErrors("frmMain")

    validateField("inp_targetTenant", targetTenant, "required", opt)

    // log.debug("VALIDATE: opt=", opt)

    if (opt.focusEl) {
      document.getElementById(opt.focusEl).focus()
    }

    return opt.valid

  }

  async function handleMoveClick() {

    // log.debug("handleMoveClick: invoked")

    if (validate()) {

      // log.debug("handleMoveClick: invoked 2")

      try {

        setBusy(intl.msg("working"))

        const payload = {
          // brandId: props.tenant.brandId,
          // tenantId: props.tenant.tenantId,
          // userId: props.row.userId,
          // emailAddress: emailAddress,
          // oldEmailAddress: oldEmailAddress,
          // modifiedBy: tenant.accessingAs("*/INSTREAM/*") ? session.user.userId : tenant.owner.userId
        }

        // log.debug("handleMoveClick: payload=", payload)

        const {data} = await api.moveUser(payload)

        // log.debug("handleMoveClick: data=", data)
      }
      catch (error) {
        handleError(error)
      }
      finally {
        setBusy(null)
      }
    }
    else {
      setAlert({type: "error", text: intl.msg("error_validation")})
    }
  }

  function getErrorMsg(error) {
    let res = null
    if (error && error.code) {
      // log.debug("1 getErrorMsg: error=", error)
      const code = error.code
      const details = error.details
      // log.debug("2 getErrorMsg: details=", details)
      res = {
        code: code
      }
      switch (code) {
        case "DUPLICATE_USER":
          res.msg = intl.msg("invite_error_duplicate_user", details)
          res.field = "inp_change_emailAddresses"
          res.constraint = "unique"
          res.details = details
          break
        case "DUPLICATE_EMAIL_ADDRESS":
          res.msg = intl.msg("invite_error_duplicate_user", details)
          res.field = "inp_change_emailAddresses"
          res.constraint = "unique"
          res.details = details
          break
        case "INVITEE_NOT_FOUND":
          res.msg = intl.msg("invite_error_invitee_not_found", details)
          res.field = "inp_change_emailAddresses"
          res.constraint = "unique"
          res.details = details
          break
        case "DUPLICATE_INVITATION":
          res.msg = intl.msg("invite_error_duplicate_tenant", details)
          res.field = "inp_change_emailAddresses"
          res.constraint = "unique"
          res.details = details
          break
        case "DUPLICATE_KEY":
          res.msg = intl.msg("invite_error_duplicate_user", details)
          res.field = "inp_change_emailAddresses"
          res.constraint = "unique"
          res.details = details
          break
        case "SUPPRESSED_EMAIL_ADDRESS":
          res.msg = intl.msg("invite_error_suppressed_user", details)
          res.field = "inp_change_emailAddresses"
          res.constraint = "valid"
          res.details = details
          break
        default:
          res.msg = intl.msg("error_failed", details)
          break
      }
    }
    else {
      return intl.msg("error_failed")
    }
    return res
  }

  function handleError(error) {
    const msg = getErrorMsg(error)
    if (msg) {
      setAlert({type: "error", text: msg.msg})
      if (msg.field) {
        showError(msg.field, msg.constraint)
      }
    } else {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  function handleTargetTenantChange(v) {
    setTargetTenant(v)
    setTouched(true)
  }

  function handleOpenDialog() {
    // log.debug("handleOpenDialog: props=", props)
    setAlert(null)
    setTouched(false)
  }

  function handleCloseDialog() {
    closeDialog("dlg_member_move")
  }

  async function loadSubTenants(search, loadedOptions, options) {

    let filters = {tenantType:["AFFILIATE", "CLIENT", "RESELLER"]}
    if (search) {
      filters.tenantName = search
    }

    return api.listSubTenants({tenantId: session.user.tenantId, extraParams: mkExtraParams({filterParams: filters, sortParams: {tenantName: "ASC"}}), cursor: options?.cursor})
      .then(({data, nextCursor}) => {
        let opt = data.map(c => {
          return {
            value: c.tenantId,
            label: <div className="d-flex flex-row">
              <div className="w-fit-content">
                 {c.tenantName}
              </div>
              <TagBox className="d-span">
                <TagLabel label={c.tenantTypeId} size="md" className="d-span"/>
                {
                  shortIdEqual(c.tenantId, session.user.tenantId) &&
                    <TagLabel label={intl.msg("you")} size="sm" className="d-span"/>
                }
              </TagBox>
            </div>,
            tenantId: c.tenantId,
            tenantTypeId: c.tenantTypeId,
          };
        });
        opt = opt.filter(o => !["INVITING", "ONBOARDING"].includes(o.tenantTypeId) && !shortIdEqual(o.tenantId, props?.tenant?.tenantId))
        let res = {
          options: opt,
        }
        if (nextCursor) {
          res = {
            ...res,
            hasMore: true,
            additional: {
              cursor: nextCursor
            }
          }
        }
        // log.debug("loadSubTenants: res=", res)
        return res
      })
      .catch((error) => {
        // log.debug("Error loading reseller: ", error)
      })
  }

  return (
    props.row &&
    <>
      <ModalDialog
        id="dlg_member_move"
        size="md"
        keyboard="true"
        backdrop="static"
        onOpen={handleOpenDialog}
        onClose={handleCloseDialog}>

        <ModalDialog.Header title={intl.msg(`member_move_title`)} description={intl.msg(`member_move_description`)} alert={alert}/>

        {
          !alert &&
          <ModalDialog.Body>

            <Alert alert={{type: "warning", text: intl.msg(`member_move_alert`, {displayName: props.row?.displayName})}}/>

            <FormGroup className="mt-3">
              <FormGroup.Label htmlFor="inp_targetTenant" text={intl.msg("member_move_target_tenant")} description={intl.msg("member_move_target_tenant_description")}/>
              <FormGroup.Control>
                <AsyncPaginate
                  id="inp_targetTenant"
                  className="react-select"
                  classNamePrefix="react-select"
                  cacheOptions
                  value={targetTenant}
                  menuIsOpen={true}
                  isSearchable={true}
                  debounceTimeout={800}
                  defaultOptions={true}
                  placeholder={null}
                  hideSelectedOptions={true}
                  loadOptions={loadSubTenants}
                  onChange={handleTargetTenantChange}
                />
              </FormGroup.Control>
            </FormGroup>

          </ModalDialog.Body>
        }

        <ModalDialog.Footer>
          <ModalDialog.Footer.Controls>
            <ActionButton name="cancel" flavor="secondary" onClick={handleCloseDialog}/>
            <ActionButton name="move" confirm={intl.msg("confirm_move")} flavor="primary" disabled={alert || !targetTenant} onClick={handleMoveClick}/>
          </ModalDialog.Footer.Controls>
        </ModalDialog.Footer>

      </ModalDialog>
    </>
  )
}